import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Sede } from "../types";

export default function BanderaContacto() {
  const { t } = useTranslation();

  const sedes: Sede[] = [
    { id: "argentina", img: "/argentina.webp" },
    { id: "espana", img: "/espana.webp" },
    { id: "chile", img: "/chile.webp" },
  ];

  return (
    <Box 
      component={motion.div}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="bandera-contacto-seccion" 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        gap: 6, 
        py: { xs: 0, md: 4 }, 
        pl: { md: 4 } 
      }}
    >
      <Box className="empresa-banderas-contacto" sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {sedes.map((sede) => (
          <Box 
            key={sede.id} 
            className="bandera-contacto-item"
            sx={{ 
              display: "flex", 
              gap: 3, 
              alignItems: "flex-start",
              "&:hover .flag-container": {
                transform: "scale(1.05)",
                boxShadow: "0 10px 20px rgba(104,168,222,0.35)"
              },
              "&:hover .country-title": {
                color: "#68a8de"
              }
            }}
          >
            <Box 
              className="flag-container"
              sx={{
                width: 96,
                height: 96,
                borderRadius: "50%",
                overflow: "hidden",
                border: "4px solid white",
                boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
                flexShrink: 0,
                position: "relative",
                transition: "all 0.3s ease"
              }}
            >
              <Box 
                component="img" 
                src={sede.img} 
                alt={t(`sedes.${sede.id}.pais`) || sede.id} 
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography 
                variant="h5" 
                className="country-title"
                sx={{ 
                    
                  fontWeight: 700, 
                  color: "#0A1128", 
                  mb: 1,
                  transition: "color 0.3s ease"
                }}
              >
                {t(`sedes.${sede.id}.pais`)}
              </Typography>
              
              <Typography 
                variant="body2" 
                sx={{ 
                  color: "#475569", 
                  whiteSpace: "pre-line", 
                  lineHeight: 1.6,
                   
                  fontSize: "0.95rem"
                }}
              >
                {t(`sedes.${sede.id}.direccion`)}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}